var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcCalendar = function SvgIcCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#767884",
    d: "M7.6 2.5a.6.6 0 0 0-1.2 0h1.2m-1.2 3a.6.6 0 0 0 1.2 0H6.4m7.2-3a.6.6 0 1 0-1.2 0h1.2m-1.2 3a.6.6 0 1 0 1.2 0h-1.2M7 2.5h-.6v3h1.2v-3zm6 0h-.6v3h1.2v-3zM17 8v-.6H3v1.2h14z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    x: 3,
    y: 3.5,
    stroke: "#767884",
    strokeWidth: 1.2,
    rx: 2
  })));
};
export default SvgIcCalendar;